// extracted by mini-css-extract-plugin
module.exports = {"list":"StickersList_list__2G03u"};